var emptyClientRect = {
    bottom: -100,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0,
    x: 0,
    y: 0,
};
export var getClientRect = function (ref) {
    return ref && ref.current ? ref.current.getBoundingClientRect() : emptyClientRect;
};



//////////////////
// WEBPACK FOOTER
// ./src/utils/tooltip/getClientRect.ts
// module id = 1132
// module chunks = 3